import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { provideAnimations } from '@angular/platform-browser/animations'
import {
  PreloadAllModules,
  provideRouter,
  withDebugTracing,
  withHashLocation,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router'
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular'
import { routes } from './app.routes'
import { CoreModule } from './core/core.module'
import { initializer } from './core/utils/app-init'
import { AppKeycloakGuard } from './guard/app.keycloakguard'

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withHashLocation(),
      withPreloading(PreloadAllModules),
      withDebugTracing(),
    ),
    importProvidersFrom(
      BrowserModule,
      // core & shared
      CoreModule,
      // keycloak
      KeycloakAngularModule,
    ),
    provideAppInitializer(() => {
      const initializerFn = initializer(inject(KeycloakService))
      return initializerFn()
    }),
    provideAnimations(),
    AppKeycloakGuard,
  ],
}
